import React from 'react';
import {BACKGROUND_COLOR, BG} from 'constants/index';

import * as styles from './styles.module.scss';

export enum Circle {
	primary = 'primary',
	secondary = 'secondary',
}

interface IProps {
	children: React.ReactNode;
	bg?: BG;
	circle?: Circle;
}

const circleStyles = (c: Circle): string[] => {
	return [...Array(10).keys()]
		.map((i) => styles[`${c}Circle${i+1}`])
		.filter((v) => !!v);
};

const LaptopSizeWrapper: React.FC<IProps> = ({
	children,
	bg = BG.transparent,
	circle,
}) => {
	const bgColor = BACKGROUND_COLOR[bg];
	const circles = !circle ? null : (
		<div className={styles.circles}>
			<div className={styles.inner}>
				{circleStyles(circle).map((c, i) => (
					<div key={i} className={c} />
				))}
			</div>
		</div>
	);

	return (
		<div style={{backgroundColor: bgColor}}>
			<div className={styles.container}>
				<div className={styles.content}>{children}</div>
				{circles}
			</div>
		</div>
	);
};

export default LaptopSizeWrapper;
